import * as React from "react";
const SvgEllipse = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 1", cx: 4, cy: 4, r: 4, fill: "#009999" }));
export default SvgEllipse;
